export enum GovernanceColumns {
  ID = "id",
  ModelStatus = "modelStatus",
  ApprovalStatus = "approvalStatus",
  ModifiedBy = "modifiedBy",
  ModifiedDate = "modifiedDate",
  ChangeNote = "changeNote",
}
